import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import centralized filter config

const D01BarChartViz06 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const demcat06Order = [
      "Traditionalists",
      "Baby Boomers",
      "Generation X",
      "Millennials",
      "Generation Z",
      "No Response",
    ];

    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by demcat06 (demographic_category_06 in the new JSON)
    const demcat06Counts = filteredData.reduce((acc, item) => {
      const demcat06 = item.demographic_category_06; // Use demographic_category_06 for demcat06
      if (!acc[demcat06]) {
        acc[demcat06] = 0;
      }
      acc[demcat06]++;
      return acc;
    }, {});

    // Sort the tenures according to `demcat06Order`
    const sorteddemcat06Data = demcat06Order.map((demcat06) => ({
      demcat06,
      count: demcat06Counts[demcat06] || 0,
    }));

    const demcat06Names = sorteddemcat06Data.map((item) => item.demcat06);
    const chartData = sorteddemcat06Data.map((item) => item.count);

    // Update state
    setCategories(demcat06Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25; // Set bar height in pixels
    const minBars = 10; // Minimum number of bars to display
    const chartHeight = Math.max(
      barHeight * demcat06Names.length,
      barHeight * minBars
    ); // Total chart height

    // Chart options
    const optionsViz06 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight, // Dynamic height based on number of bars
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat06Names,
      },
    };

    // Render the chart
    const viz06 = new ApexCharts(
      document.querySelector("#viz-06"),
      optionsViz06
    );
    viz06.render();

    // Cleanup chart on component unmount
    return () => {
      viz06.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-06"></div>
    </div>
  );
};

export default D01BarChartViz06;
